import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { DynamicModule } from 'ng-dynamic-component';

import { AccordionComponent as SbAccordionComponent } from '@valk-nx/storyblok/components/accordion/src/lib/accordion';
import { ActivateGiftcardComponent } from '@valk-nx/storyblok/components/activate-giftcard/src/lib/activate-giftcard';
import { AnchorComponent } from '@valk-nx/storyblok/components/anchor/src/lib/anchor';
import { BalanceGiftcardComponent } from '@valk-nx/storyblok/components/balance-giftcard/src/lib/balance-giftcard';
import { CardComponent } from '@valk-nx/storyblok/components/card/src/lib/card';
import { DealCardComponent } from '@valk-nx/storyblok/components/deal-card/src/lib/deal-card';
import { FormComponent } from '@valk-nx/storyblok/components/form/src/lib/form';
import { HeadingGroupComponent } from '@valk-nx/storyblok/components/heading-group/src/lib/heading-group';
import { HeadingGroupSectionComponent } from '@valk-nx/storyblok/components/heading-group-section/src/lib/heading-group-section';
import { ImageComponent as SbImageComponent } from '@valk-nx/storyblok/components/image/src/lib/image';
import { MapComponent } from '@valk-nx/storyblok/components/map/src/lib/map';
import { MarkdownComponent } from '@valk-nx/storyblok/components/markdown/src/lib/markdown';
import { MiniCarouselComponent as SbMiniCarouselComponent } from '@valk-nx/storyblok/components/mini-carousel/src/lib/mini-carousel';
import { OrderGiftcardComponent } from '@valk-nx/storyblok/components/order-giftcard/src/lib/order-giftcard';
import { OrderGiftcardBusinessComponent } from '@valk-nx/storyblok/components/order-giftcard-business/src/lib/order-giftcard-business';
import { PackageCardComponent } from '@valk-nx/storyblok/components/package-card/src/lib/package-card';
import { RichTextComponent } from '@valk-nx/storyblok/components/richtext/src/lib/rich-text';
import { RunningHeadComponent } from '@valk-nx/storyblok/components/running-head/src/lib/running-head';
import { SheetComponent } from '@valk-nx/storyblok/components/sheet/src/lib/sheet';
import { UspWrapperComponent } from '@valk-nx/storyblok/components/usp-wrapper/src/lib/usp-wrapper';
import { VideoComponent } from '@valk-nx/storyblok/components/video/src/lib/video';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { ISbStoryBlok } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

const Components = {
	accordion: SbAccordionComponent,
	activateGiftcard: ActivateGiftcardComponent,
	balanceGiftcard: BalanceGiftcardComponent,
	button: AnchorComponent,
	card: CardComponent,
	dealCard: DealCardComponent,
	form: FormComponent,
	headingGroup: HeadingGroupComponent,
	headingGroupSection: HeadingGroupSectionComponent,
	hotelMap: MapComponent,
	image: SbImageComponent,
	markdown: MarkdownComponent,
	miniCarousel: SbMiniCarouselComponent,
	orderGiftcard: OrderGiftcardComponent,
	orderGiftcardBusiness: OrderGiftcardBusinessComponent,
	packageCard: PackageCardComponent,
	richText: RichTextComponent,
	runningHead: RunningHeadComponent,
	sheet: SheetComponent,
	video: VideoComponent,
	uspwrapper: UspWrapperComponent,
};

@Component({
	selector: 'sb-columns',
	templateUrl: './columns.html',
	imports: [CommonModule, DynamicModule, StoryblokDirective],
})
export class ColumnsComponent extends StoryblokRootDirective {
	colOne = input.required<ISbStoryBlok[]>();
	colTwo = input<ISbStoryBlok[] | undefined>(undefined);
	colThree = input<ISbStoryBlok[] | undefined>(undefined);
	colAlignment = input<
		'symmetrical' | 'asymmetricalLeft' | 'asymmetricalRight'
	>('symmetrical');

	components: typeof Components = Components;

	constructor() {
		super();
	}
}
